import { ButtonRounded, Caption, H3, Card, CardBlock, LabelRegular } from '@comeon/ui';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import useTranslations from '~/components/translation/use-translations.ts';
import { WE_SPIN_BECOME_PRIVATE_STREAMER_TEXT_KEYS } from './constants/we-spin-text-keys.js';
import { WE_SPIN_FRIENDS_RESOURCE_KEY_LOBBY_CARD_IMAGE } from './constants/we-spin-friends-resource-keys.js';
import useOpenCreateEvent from './use-open-create-event.js';
import { selectIsBlockedStreamer } from './ducks/we-spin-dashboard-duck';

const WeSpinTutorialContentBlock = styled(CardBlock)`
	background: transparent;
	flex-direction: column;
	width: 100%;
	flex: initial;
	justify-content: center;
	align-items: center;
`;

const WeSpinTutorialHeaderBlock = styled(CardBlock)`
	background: transparent;
	overflow: hidden;
	flex-direction: column;
	flex: initial;
	padding: 0 12px;
`;

const Figure = styled.figure`
	color: var(--we-spin-create-stream-card-text, var(--we-spin-clip-card-text));
	height: 348px;
	order: 1;

	h3 {
		color: var(--we-spin-create-stream-card-title, var(--we-spin-clip-card-title));
	}
`;

const getStyles = backgroundImage => {
	return {
		style: {
			backgroundImage: `var(--we-spin-tutorial-card-bg-gradient), url(${backgroundImage})`,
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'cover',
			backgroundPosition: 'top center',
			borderRadius: '3px',
			transition: 'opacity 0.25s',
			linear: '0s',
			opacity: 1,
			justifyContent: 'flex-end',
			minHeight: '336px'
		}
	};
};

const WeSpinCreateEventCard = ({ onClick, resources }) => {
	const onOpenCreateEvent = useOpenCreateEvent();
	const isBlockedStreamer = useSelector(selectIsBlockedStreamer);

	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_BECOME_PRIVATE_STREAMER_TEXT_KEYS);

	return (
		!isLoadingTranslations && (
			<Figure className="item--large-we-spin tutorial-card u-b-radius u-relative u-m0 u-pb1">
				<Card {...getStyles(resources[WE_SPIN_FRIENDS_RESOURCE_KEY_LOBBY_CARD_IMAGE])}>
					<WeSpinTutorialHeaderBlock>
						<Caption>{tr.WE_SPIN_BECOME_PRIVATE_STREAMER_CARD_TITLE}</Caption>
						<H3 mt={2} mb={3}>
							{tr.WE_SPIN_BECOME_PRIVATE_STREAMER_CARD_CONTENT}
						</H3>
					</WeSpinTutorialHeaderBlock>
					<WeSpinTutorialContentBlock>
						<Caption>{tr.WE_SPIN_FRIENDS_LOBBY_CARD_TUTORIAL_DESCRIPTION}</Caption>

						<ButtonRounded
							className="btn btn--light btn--wespin u-width-100 u-mt1 "
							onClick={onOpenCreateEvent}
							disabled={isBlockedStreamer}
						>
							{tr.WE_SPIN_BECOME_PRIVATE_STREAMER_CARD_BUTTON}
						</ButtonRounded>
						<ButtonRounded className="btn btn--tutorial-card-button" onClick={onClick}>
							<LabelRegular my={1} id="tutorial-card-link" className="we-spin-tutorial-card-link">
								{tr.WE_SPIN_BECOME_PRIVATE_STREAMER_CARD_TUTORIAL_BUTTON}
							</LabelRegular>
						</ButtonRounded>
					</WeSpinTutorialContentBlock>
				</Card>
			</Figure>
		)
	);
};

export default WeSpinCreateEventCard;
